import React from 'react';
import styled from 'styled-components';
import { Alert } from '@tvg/fuse-design/alert';
import { gridConfig } from '@tvg/fuse-design/responsive-grid';

const Container = styled.div`
  margin-bottom: 0;

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    margin-bottom: var(--spacing-space4);
    margin-top: var(--spacing-space16);
  }

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    margin-top: 0;
  }
`;

function NoResultsAlert() {
  return (
    <Container>
      <Alert
        heading="No matching results"
        message="The filters you've applied don't return any matching products. Please change your selection."
        showIcon
        variant="information"
        role="alert"
      />
    </Container>
  );
}

export default NoResultsAlert;
